__webpack_require__.p = "https://debasish-g1t.github.io/";